import { render, staticRenderFns } from "./AddCharges.vue?vue&type=template&id=8a67a3f0&scoped=true"
import script from "./AddCharges.vue?vue&type=script&lang=js"
export * from "./AddCharges.vue?vue&type=script&lang=js"
import style0 from "./AddCharges.vue?vue&type=style&index=0&id=8a67a3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67a3f0",
  null
  
)

export default component.exports